import styled from "styled-components";

export const HomepageHeaderArenaMenuItemNameDefaultBox = styled.div`
  position: relative;
  display: inline;
  font-size: 1.8rem;
  letter-spacing: 1px;
  padding-left: 1.2rem;
  ${({theme}) => theme.font.presets.bold}
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    font-size: 1rem;
    padding-left: 0.5rem;
  }
`;
